'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * The communities this setup currently supports (i.e. with icons or the
 * shareActionFactory.
 * Currently supports `twitter`, `facebook`, `whatsapp` and `share`.
 * @module supportedCommunities
 */
exports.default = ['twitter', 'facebook', 'whatsapp', 'share'];


//////////////////
// WEBPACK FOOTER
// ./~/@ta-interaktiv/react-share-buttons/dist/supportedCommunities.js
// module id = 68
// module chunks = 0